import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled as muiStyled } from '@mui/material';

const ChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 102px;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.colors.clearGray};
  background-color: ${props => props.theme.colors.primaryWhite};
  overflow: hidden;
  max-height: 140px;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 16px;
  border: none;
  outline: none;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  background-color: transparent;
  min-height: 60px;
  flex-grow: 1;
  scrollbar-width: thin;
  overflow-y: auto;
  
  &::placeholder {
    color: ${props => props.theme.colors.davysGrey};
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  position: relative !important;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  min-height: 42px;
  border: none !important;
  background-color: transparent !important;
  width: 100%;
`;

const LeftActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${props => props.theme.colors.darkGray};
  
  &:hover {
    color: ${props => props.theme.colors.black};
  }

  &:disabled {
    color: ${props => props.theme.colors.silverGrayFour};
    cursor: not-allowed;
  }
`;

const SendIconButton = styled(IconButton)`
  background-color: ${props => props.showSpinner ? '#535353' : '#000'};
  color: #fff;
  border-radius: 5px;
  min-width: 28px;
  min-height: 28px;
  padding: 4px;
  
  &:hover {
    color: #fff;
    background-color: ${props => props.showSpinner ? '#535353' : '#333'};
  }
  
  &:disabled {
    background-color: #535353;
    color: #aaa;
  }
`;

const FileAttachmentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.silverGrayThree};
  border-radius: 8px;
  
  span {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
`;

const StopButton = styled(IconButton)`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.black};
  padding: 0;
  
  & > span {
    width: 12px;
    height: 12px;
    background-color: ${props => props.theme.colors.white};
  }
`;

const IsUploadingWrapper = styled(CircularProgress)`
  max-width: 20px;
  max-height: 20px;
`;

const ErrorMessageContainer = styled.div`
  color: ${(props) => props.theme.colors.red};
  padding: 4px 16px; 
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap:8px;
`;

const WebSearchButton = styled(IconButton)`
  background-color: ${props => props.enabled ? '#e3f2fd' : 'transparent'};
  border: ${props => props.enabled ? '1px solid #2196f3' : '1px solid transparent'};
  border-radius: 6px;
  color: ${props => props.enabled ? '#1976d2' : props.theme.colors.darkGray};
  
  &:hover {
    background-color: ${props => props.enabled ? '#bbdefb' : '#f5f5f5'};
    color: ${props => props.enabled ? '#1565c0' : props.theme.colors.black};
  }
`;

const ReasoningAgentButton = styled(IconButton)`
  background-color: ${props => props.enabled ? '#EEF2FF' : 'transparent'};
  border: ${props => props.enabled ? '2px solid #4F46E5' : '1px solid transparent'};
  border-radius: 6px;
  color: ${props => props.enabled ? '#4F46E5' : props.theme.colors.darkGray};
  
  &:hover {
    background-color: ${props => props.enabled ? '#E0E7FF' : '#f5f5f5'};
    color: ${props => props.enabled ? '#4338CA' : props.theme.colors.black};
  }
`;

const StyledTooltip = muiStyled(({ className, ...props}) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    height: '36px',
    width: '135px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    padding: '16px',
    backgroundColor: 'rgba(97, 97, 97, 0.9)',
    borderRadius: '4px'
  }
});

export {
  ChatWrapper as InputContainer,
  ChatWrapper,
  TextArea,
  TextArea as StyledTextArea,
  ActionsContainer,
  LeftActions,
  RightActions,
  IconButton,
  SendIconButton,
  FileAttachmentContainer,
  StopButton,
  IsUploadingWrapper,
  ErrorMessageContainer,
  StyledTooltip,
  WebSearchButton,
  ReasoningAgentButton
}; 